/* =========================================================================
   SWGEAR Header Nav Dropdown
   - Opens on mouseenter or focus (trigger OR panel)
   - Closes on mouseleave with a 250ms grace period (lets pointer cross any
     small gap between trigger and panel without the menu collapsing)
   - Click-toggle: tapping the caret toggles open/close
   - Closes on Escape, click outside, or focus leaving the item
   - Keeps the CSS :hover / :focus-within selectors as a no-JS fallback
   ========================================================================= */

(function () {
  'use strict';

  const CLOSE_DELAY = 250;
  const OPEN_CLASS = 'is-open';

  function setup(item) {
    if (!item || item.dataset.swgearNavBound === '1') return;
    item.dataset.swgearNavBound = '1';

    const trigger = item.querySelector('.swgear-header__link--has-dropdown');
    const panel = item.querySelector('.swgear-header__dropdown');
    if (!trigger || !panel) return;

    let closeTimer = null;

    function open() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      item.classList.add(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close(immediate) {
      if (closeTimer) clearTimeout(closeTimer);
      if (immediate) {
        item.classList.remove(OPEN_CLASS);
        trigger.setAttribute('aria-expanded', 'false');
        closeTimer = null;
        return;
      }
      closeTimer = setTimeout(() => {
        item.classList.remove(OPEN_CLASS);
        trigger.setAttribute('aria-expanded', 'false');
        closeTimer = null;
      }, CLOSE_DELAY);
    }

    // Pointer: cover both the trigger area and the panel.
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', () => close(false));

    // Click on the caret toggles; click on the label still navigates normally.
    const caret = item.querySelector('.swgear-header__caret');
    if (caret) {
      caret.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (item.classList.contains(OPEN_CLASS)) {
          close(true);
        } else {
          open();
        }
      });
    }

    // Keyboard: focus inside opens, focus leaving closes.
    trigger.addEventListener('focus', open);
    panel.addEventListener('focusin', open);
    item.addEventListener('focusout', (e) => {
      // Only close when focus actually leaves the nav-item subtree.
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      close(false);
    });

    // Escape closes and returns focus to the trigger.
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && item.classList.contains(OPEN_CLASS)) {
        e.preventDefault();
        close(true);
        trigger.focus();
      }
    });

    // Click outside closes.
    document.addEventListener('click', (e) => {
      if (!item.contains(e.target) && item.classList.contains(OPEN_CLASS)) {
        close(true);
      }
    });
  }

  function init(root) {
    const scope = root || document;
    scope.querySelectorAll('.swgear-header__nav-item--has-dropdown').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Re-init on theme editor section reload.
  document.addEventListener('shopify:section:load', (e) => {
    init(e.target);
  });
})();
